import React, {Component, PropTypes} from 'react'

class PageTitle extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.contentClassification = props.contentClassification || ''
    this.title = props.title || ''


  }

  componentDidMount(){

    if(!this.contentClassification )
      return null

      window.gptadslots = window.gptadslots || [];
      window.googletag = window.googletag || {
        cmd: []
      };

      googletag.cmd.push(() =>{
        console.log('PageTitle created ad %s', '/43459271/loc-desktop/'+ this.props.affiliate+ '/web/' + this.contentClassification)
        gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+ this.props.affiliate+ '/web/' + this.contentClassification,
        [[1, 1]],'gnm-responsive-page-title-ad-container').addService(googletag.pubads()));

        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      window.googletag.cmd.push(function() {
        googletag.display('gnm-responsive-page-title-ad-container')
      });

  }


  render() { // REQUIRED
      return (
        <div className='gnm-page-title'>
          <h1 className='white-at-small h2'>{this.title}</h1>
          <span id='gnm-responsive-page-title-ad-container' className='ad-tag'></span>
          <div className='clearfix'></div>
          <div className ="hidden-sm hidden-xs" dangerouslySetInnerHTML={{__html: this.props.subTitle}} ></div>
        </div>
      )
  }
}

export default PageTitle



// WEBPACK FOOTER //
// ./app/components/custom/ssr/PageTitle/index.js